import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';
import { antdTheme } from './theme/antdTheme';
import { Header } from './sections/Header';
import { Footer } from './sections/Footer';
import { HomePage } from './templates/HomePage';
import { HandicapsPage } from './templates/HandicapsPage';
import { ParcoursPage } from './templates/ParcoursPage';
import { ParcoursFichePage } from './templates/ParcoursFichePage';
import { AdminPage } from './templates/AdminPage';
import { NotFoundPage } from './templates/NotFoundPage';
import { SoonPage } from './templates/Soon';

function App() {
  return (
    <ConfigProvider theme={antdTheme}>
      <Router>
        <Routes>
          {/* Route d'administration sécurisée */}
          {/* <Route path="/gestion-contenu-a7b9c2" element={<AdminPage />} /> */}

          {/* Pages avec header/footer normaux */}
          <Route path="/" element={
            <Layout className="min-h-screen bg-neutral-white">
              <Header />
              <HomePage />
              <Footer />
            </Layout>
          } />
          <Route path="/mentions-legales" element={
            <Layout className="min-h-screen bg-neutral-white">
              <Header />
              <SoonPage />
              <Footer />
            </Layout>
          } />

          <Route path="/cgu" element={
            <Layout className="min-h-screen bg-neutral-white">
              <Header />
              <SoonPage />
              <Footer />
            </Layout>
          } />

          <Route path="/handicaps" element={
            <Layout className="min-h-screen bg-neutral-white">
              <Header />
              <HandicapsPage />
              <Footer />
            </Layout>
          } />

          {/* Pages de parcours avec gestion spéciale */}
          <Route path="/parcours/:slug" element={<ParcoursPage />} />
          <Route path="/parcours/:slug/mission/:missionId" element={<ParcoursPage />} />
          <Route path="/parcours/:slug/fiche" element={<ParcoursFichePage />} />

          {/* Page 404 */}
          <Route path="*" element={
            <Layout className="min-h-screen bg-neutral-white">
              <Header />
              <NotFoundPage />
              <Footer />
            </Layout>
          } />
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;